'use client';

import Sidebar from '@/components/Sidebar';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import BangDonThu from './components/BangDonThu';

export default function DonThuPage(props) {
  const { rightBanners, linkPages, websiteCode, slugDetail } = props;

  return (
    <div className="flex flex-col min-h-screen">
      <div className={twMerge('container mx-auto bg-white', slugDetail ? 'px-2 md:px-4 py-2' : '')}>
        <div className="flex flex-col lg:flex-row gap-6">
          <section className="lg:w-3/4 ">
            <BangDonThu {...props} />
          </section>
          <section className="w-full md:w-1/4 ">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </section>
        </div>
      </div>
    </div>
  );
}
